import * as monaco from 'monaco-editor';
import { InterpretWorker } from 'interpret/worker/InterpretWorker';
import { editorOptions, modelOptions } from 'monaco/editorSetup';

export const editorElement = document.createElement('div');
editorElement.style.width = '100%';
editorElement.style.height = '100%';

export const model = monaco.editor.createModel(modelOptions.value, modelOptions.language);

const interpretWorker = new Worker(new URL('../../../../../../interpret/worker/Worker', import.meta.url));

export const worker = monaco.editor.createWebWorker<InterpretWorker>({
  worker: interpretWorker,
});

const editor = monaco.editor.create(editorElement, editorOptions(model));

export default editor;
